<template>
  <div class="tourn-card row row-cols-1 row-cols-md-2 row-cols-xxl-4 g-4 gy-5">
    <template v-for="(item, index) in tournamentlist">
      <div class="col" :key="index">
        <router-link
          :to="{ name: 'Condition', params: { id: item.tournamentno } }"
        >
          <div class="card h-100">
            <div class="card-img-wrapper">
              <img
                :src="
                  item.tourbinary &&
                  item.tourbinary[0] &&
                  item.tourbinary[0].filepath_web
                    | get_img(
                        'https://indonesiastorage.s3.ap-southeast-3.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                      )
                "
              />
            </div>
            <div class="card-body">
              <p class="badge-group">
                <span class="badge tourn-type">
                  {{ tournament_type(item.tourtype_fk) }}
                </span>
                <!-- <span class="badge tourn-game-type">
                  {{ game_type(item.gametype_fk) }}
                </span> -->
              </p>
              <h5 class="tourn-title line-clamp-clear">{{ item.title }}</h5>
              <p class="tourn-rank-type">
                <!-- {{ game_type(tournamentinfo.gametype_fk) }} <strong>&middot;</strong>  -->
                {{ item.tour_rank_type | tour_rank_type }}
              </p>
            </div>
            <div class="card-footer">
              <template
                v-if="
                  item.timezone_startdate &&
                  item.timezone_startdate.timezone_private
                "
              >
                <p class="text-date text-truncate mb-1">
                  <dfn
                    class="time-zone-mark badge rounded-pill bg-orange"
                    title="Connect time"
                    >CT</dfn
                  >
                  {{ item.timezone_startdate.timezone_private | dateformat }}
                  ~
                  {{ item.timezone_enddate.timezone_private | dateformat }}
                </p>
              </template>

              <!-- 서비스 시간 -->
              <p class="text-date text-truncate">
                <dfn
                  class="time-zone-mark badge rounded-pill bg-green"
                  title="Standard time"
                  >ST</dfn
                >
                {{ item.timezone_startdate.timezone_common | dateformat }}
                ~
                {{ item.timezone_enddate.timezone_common | dateformat }}
              </p>
            </div>
          </div>
        </router-link>
      </div>
    </template>
  </div>
</template>
<script>
import { myMixin } from "@/mixin/myMixin";
export default {
  name: "Tournament",
  props: ["tournamentlist"],
  mixins: [myMixin],
};
</script>
